<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listPeriodoVigencia"
        title-table="Períodos de Vigência"
        module="periodoVigenciaSettingsModule"
        sort-name="dataInicio"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      >
        <template #buttons>
          <b-button
            variant="outline-secondary"
            class="ml-1"
            :to="{ name: 'mensalidades-dashboard' }"
          >
            <feather-icon icon="ChevronLeftIcon" />
            Voltar para Contribuições
          </b-button>
        </template>
      </TableComponents>
      <FormPeriodoVigencia
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol, BButton } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormPeriodoVigencia from './forms/FormPeriodoVigencia.vue'

export default {
  name: 'PeriodoVigenciaSetting',
  components: {
    BRow,
    BCol,
    BButton,
    TableComponents,
    FormPeriodoVigencia,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Início',
          field: 'dataInicio',
          formatFn: this.formatDate,
        },
        {
          label: 'Fim',
          field: 'dataFim',
          formatFn: this.formatDate,
        },
        {
          label: this.$t('Active'),
          field: 'ativo',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  computed: {
    ...mapState('periodoVigenciaSettingsModule', {
      listPeriodoVigencia: state => state.listPeriodoVigencia,
    }),
  },
  mounted() {
    this.$store.dispatch('periodoVigenciaSettingsModule/loadTable', { size: 100 })
  },
  methods: {
    addNew() {
      this.$store.dispatch('periodoVigenciaSettingsModule/resetPeriodoVigencia')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('periodoVigenciaSettingsModule/prepareToEditPeriodoVigencia', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('periodoVigenciaSettingsModule/loadTable', { size: 100 })
    },
  },
}
</script>
